import { render, staticRenderFns } from "./InDmFrame.vue?vue&type=template&id=b88ec128&scoped=true"
import script from "./InDmFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./InDmFrame.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InDmFrame.vue?vue&type=style&index=0&id=b88ec128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88ec128",
  null
  
)

export default component.exports